module.exports = __webpack_public_path__ + "static/media/csr_5_pengrajin_wanita_di_lombok.4dc094a7.jpg";